import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { BrowserHelperService } from '../services/browser-helper.service';

export const browserCompatibilityGuard: CanActivateFn = (route, state) => {
  const browserHelperService = inject(BrowserHelperService);
  const router = inject(Router);

   if(browserHelperService.isInAppBrowser()){
    router.navigate(['/browser-compatibility']);
    return false;
  }else if (!browserHelperService.isSupported()) {
    router.navigate(['/recommended-browser']);
    return false;
  }

  return of(true)
};